import EditorImgVideo from 'lowcode/components/EditorImgVideo';
import css from './index.module.scss';

export default function CardA({
    pc,
    h5,
    dirType = 'imgl',
    subTitle,
    title,
    desc,
    isVideo,
}: {
    pc: string;
    h5?: string;
    dirType?: string;
    subTitle?: string;
    title?: string;
    desc?: string;
    isVideo?: boolean;
}) {
    return (
        <section className={`dpu-detail-CardA ${css['dpu-detail-CardA']}`}>
            <div className={`card-in card-dir-${dirType}`}>
                <div className="card-side-ms">
                    <div className="card-subTitle">{subTitle}</div>
                    <div className="card-title">{title}</div>
                    <div className="card-desc">{desc}</div>
                </div>
                <div className="card-side-img">
                    <EditorImgVideo pc={pc} h5={h5} isVideo={isVideo} loop={true} autoPlay={true} />
                </div>
            </div>
        </section>
    );
}
